<template>
  <div class="change-password">
    <div class="row mx-2 mt-4">
      <div class="col-md-6 mb-3">
        <Card title="Thông tin chung" :action="{ text: 'Sửa', onClick: () => $router.push('/merchant/update/' + detail.leadId), active: detail.status === 'NEW' }">
          <Content title="Người đại diện" :content="detail.customerName"></Content>
          <Content title="Email" :content="detail.email"></Content>
          <Content title="Số điện thoại" :content="detail.mobile"></Content>
          <Content title="Tên merchant" :content="detail.merchantName"></Content>
          <Content title="Địa chỉ">
            {{ getTextCountry }}
          </Content>
          <Content title="Ngành nghề" :content="detail.mccName"></Content>
          <Content title="Ghi chú" :content="detail.description"></Content>
        </Card>
        <Card v-if="isVCBHO" class="mt-4" title="Thông tin Agent VCBHO">
          <Content title="Số điện thoại liên hệ" :content="detail.contactPhoneNumber"></Content>
          <Content title="Số tài khoản VA" :content="detail.vaNumber"></Content>
          <Content title="Thời gian giao hàng">
            {{ detail.expectedDeliveryTime | formatDate }}
          </Content>
          <Content title="Số lượng máy" :content="detail.deviceQuantity"></Content>
          <Content title="Hình thức bàn giao" :content="mapHandoverType[detail.handoverType]"></Content>
          <Content title="Phường/xã" :content="detail.ward"></Content>
        </Card>
        <Card class="mt-4">
          <Content title="Trạng thái">
            <Status :value="detail.merchantAgentStatus" :config="Config.merchantStatus"/>
          </Content>
          <Content title="TG tạo">
            {{ detail.createdAt | formatDateTime7 }}
          </Content>
        </Card>
        <Card title="Ảnh" class="mt-4">
          <UploadMultiple :canUpload="false" :lsData="detail.uploadImages"/>
        </Card>
      </div>
      <div class="col-md-6 mb-3">
        <Card title="Hợp đồng">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Hợp đồng</th>
                <th scope="col">Trạng thái</th>
                <th scope="col">TG tạo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="contract in detailContract" :key="contract.id">
                <td>
                  <router-link :to="'/contract/detail/' + contract.id">{{ contract.code }}</router-link>
                </td>
                <td>
                  <Status :value="contract.contractStateAgency" :config="Config.contractStatus"/>
                </td>
                <td>
                  {{ contract.dateCreate | formatDateTime7 }}
                </td>
              </tr>
            </tbody>
          </table>
        </Card>
        <Card class="mt-4" title="Lịch sử" >
          <HistoryComponent :id="id" />
        </Card>
           <Card class="mt-4" title="Thông tin lô hàng" >
          <DeviceShipments :data="detail.deviceShipments" />
        </Card>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import Card from '@/components/common/Card.vue'
import Content from '@/components/common/Content.vue'
import { MerchantService } from '@/services/merchant.service'
import UploadMultiple from '@/components/UploadMultiple.vue'
import { ContractService } from '@/services/contract.service'
import HistoryComponent from '@/pages/merchant/history.vue'
import DeviceShipments from '@/pages/merchant/deviceShipments.vue'
const mapHandoverType = Object.freeze({
  OFFLINE: 'Offline',
  ONLINE: 'Online'
})
export default {
  data () {
    return {
      showLoading: false,
      id: '',
      detail: {},
      detailContract: [],
      mapHandoverType
    }
  },
  components: { Card, Content, UploadMultiple, HistoryComponent, DeviceShipments },
  computed: {
    getTextCountry () {
      const district = this.detail.district ?? this.detail.ward
      return `${this.detail.address}, ${district} - ${this.detail.city}`
    },
    isVCBHO () {
      return this.detail?.agentGroup && this.detail.agentGroup.includes('VCBHO')
    }
  },

  async created () {
    this.id = this.$route.params.id
  },
  async mounted () {
    this.get()
  },
  methods: {
    async get () {
      this.showLoading = true
      try {
        const res = await MerchantService.get(this.id)
        if (res.success) {
          this.detail = res.data
          this.getContract()
        } else this.showFailMx(res.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    },
    async getContract () {
      if (!this.detail.myNpMerchantId) return
      try {
        const params = { customerId: this.detail.myNpMerchantId, limit: 1000, page: 1 }
        const res = await ContractService.fetch(params)
        if (res.success) {
          this.detailContract = res.data.contractList
        } else this.showFailMx(res.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.card){
      box-shadow: none !important;
    border: 1px solid rgba(0, 0, 0, .2) !important;
}
</style>
